import React, { useMemo, useState } from "react";
import intl from "components/i18n/ReactIntlWrapper";
import { useDropzone } from "react-dropzone";
import { Box, Typography, Grid } from "@mui/material";
import DescriptionIcon from "@mui/icons-material/Description";

const StyledDropzone = ({ files, setInput, disabled = false }) => {
  const { getRootProps, getInputProps, isFocused, isDragAccept, isDragReject } =
    useDropzone({
      accept: { "image/png": [], "image/jpeg": [], "application/pdf": [] },
      onDrop: (file) => {
        if (
          file?.[0]?.type === "image/jpeg" ||
          file?.[0]?.type === "image/png" ||
          file?.[0]?.type === "application/pdf"
        ) {
          if (
            !files.some((attachment) =>
              attachment.name
                ? attachment.name == file[0].name
                : attachment == file[0].name
            )
          ) {
            setInput((prevInput) => ({
              ...prevInput,
              attachments: prevInput.attachments
                ? [...prevInput.attachments, file[0]]
                : [file[0]],
            }));
          }
        }
      },
      noClick: true,
      disabled: disabled,
    });

  const className = useMemo(() => {
    let classNames = "base-style";
    if (isFocused) classNames += " focused-style";
    if (isDragAccept) classNames += " accept-style";
    if (isDragReject) classNames += " reject-style";
    return classNames;
  }, [isFocused, isDragAccept, isDragReject]);

  return (
    <Box {...getRootProps({ className })}>
      <input {...getInputProps()} />
      <Grid
        container
        justifyContent="space-around"
        alignItems="center"
        textAlign="center"
      >
        <Grid>
          <DescriptionIcon className="iconFileTimeOff" />
        </Grid>
        <Grid>
          <Typography variant="h6" fontWeight="bold">
            {intl.get("timeOff.attached.files")}
          </Typography>
        </Grid>
        <Grid className="dropZoneText">
          <Typography variant="body2">
            {intl.get("timeOff.file.type")}
            <br />
            {intl.get("timeOff.file.size")}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default StyledDropzone;
